module.exports = __webpack_public_path__ + "static/media/arrow-right-white.02d017a6.svg";